<template>
  <div
    :class="Loading ? 'disable border rounded mt-2' : 'border rounded mt-2'"
    style="position: relative;"
  >
    <table class="table table-sm table-hover w-100">
      <thead>
        <tr>
          <th class="text-center" colspan="2">
            Gift card
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right w-35">
            <strong>Is this a gift:</strong>
          </td>
          <td class="text-left w-65">
            <b-form-checkbox v-model="order.gift" switch />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Firstname:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.userFirstname"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Lastname:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.userLastname"
            />
          </td>
        </tr>
        <tr>
          <td class="text-right w-35">
            <strong>Signature:</strong>
          </td>
          <td class="text-left w-65">
            <input
              class="form-control"
              type="text"
              name=""
              id=""
              v-model="order.signature"
            />
          </td>
        </tr>
        <tr>
          <td colspan="2" class="text-center">
            <strong>Message:</strong>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <textarea
              class="form-control"
              name=""
              id=""
              cols="30"
              rows="10"
              v-model="order.message"
            ></textarea>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <button
              type="button"
              style="display: block; margin: 0 auto;"
              class="btn btn-primary"
              @click="submit"
            >
              Update Gift Card
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="centered-spinner" v-if="Loading">
      <a-spin />
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftCard",
  data() {
    return {
      Loading: false,
    };
  },
  methods: {
    submit() {
      this.Loading = true;
      const giftCardRequest = {
        gift: this.order.gift,
        firstName: this.order.userFirstname,
        lastName: this.order.userLastname,
        signature: this.order.signature,
        message: this.order.message,
        gift_id: this.order.orderId,
      };
      this.$store
        .dispatch("orderDetails/updateGiftCard", giftCardRequest)
        .then((data) => {
          alert(data);
        })
        .finally(() => {
          this.Loading = false;
        });
    },
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
  },
};
</script>

<style lang="scss" scoped>
.w-100 {
  width: 100%;
}
.w-35 {
  width: 35%;
}
.w-65 {
  width: 65%;
}
.form-switch .form-check-input {
  width: 3em;
  height: 1.3rem;
  margin-left: -1.5em !important;
}
.centered-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
table{
  margin-bottom: 0px;
  border: solid grey 0.5px;
}
td {
  border: solid grey 0.5px;
}
</style>
